module.exports = __webpack_public_path__ + "img/chg-logo.137e9cf8.png";